import { Component, type ReactNode } from 'react'

import { scopedTranslation } from '@utils/I18n'

import { EmbedButton } from './EmbedButton'
import { EmbedEmptyState } from './EmbedEmptyState'

const t = scopedTranslation('embeds.events.error')

type EmbedErrorBoundaryProps = { children: ReactNode }

export class EmbedErrorBoundary extends Component<EmbedErrorBoundaryProps, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  render() {
    if (!this.state.failed) return this.props.children

    return (
      <div className="tw:p-4 tw:font-sans" role="alert">
        <EmbedEmptyState
          headingLevel={2}
          icon="alert-circle"
          title={t('title')}
          action={<EmbedButton onClick={() => window.location.reload()}>{t('retry')}</EmbedButton>}
        >
          <p>{t('body')}</p>
        </EmbedEmptyState>
      </div>
    )
  }
}
